import { PopupAlertsResponseSchema, type PopupAlertsResponse } from '@classic/Components/PopUpAlerts/Schemas';
import { InvalidSchemaError } from '@classic/Components/PopUpAlerts/Errors/InvalidSchema';
import { RequestError } from '@classic/Components/PopUpAlerts/Errors/RequestError';

class PopUpAlertsRepository {
    /**
     * Fetches the active (or previewed, when `previewAlertIds` is non-empty)
     * popup alerts for the current site.
     *
     * @see app/src/Controller/Api/PopupAlert/Http/ActiveAlertsFilter.php — `prevId[]` query param
     */
    public async fetchActiveAlerts(previewAlertIds: readonly number[] = []): Promise<PopupAlertsResponse> {
        const url = new URL('/api/popup-alerts', window.location.origin);
        previewAlertIds.forEach((id) => url.searchParams.append('prevId[]', String(id)));

        const response = await fetch(url.toString(), {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        });

        if (!response.ok) {
            throw new RequestError(`Popup alerts request failed with status ${response.status}`);
        }

        const json = await response.json();
        const validationResult = PopupAlertsResponseSchema.safeParse(json);

        if (!validationResult.success) {
            throw new InvalidSchemaError('Invalid popup alerts API response', validationResult.error);
        }

        return validationResult.data;
    }
}

export default PopUpAlertsRepository;
